export enum NetworkType {
    /**
     * @en Network is unreachable.
     * @zh 网络不通
     */
    NONE,
    /**
     * @en Network is reachable via WiFi or cable.
     * @zh 通过无线或者有线本地网络连接因特网
     */
    LAN,
    /**
     * @en Network is reachable via Wireless Wide Area Network
     * @zh 通过蜂窝移动网络连接因特网
     */
    WWAN,
}
